import { TAppState } from '../../types/appState';

export const internetStatusSelector = (state: TAppState) => state.internetStatus;
